//src/lib/groCrudScope.ts
import { PERMISSIONS } from "@/lib/permissions";

export type GroCrudScope = "client" | "company_model";

export const COMPANY_GRO_BASE_PATH = "/tenant/modelos/gro";

export function isCompanyGroScope(scope: GroCrudScope) {
  return scope === "company_model";
}

export function groReadPermission(scope: GroCrudScope, clientPermission: string) {
  return isCompanyGroScope(scope)
    ? PERMISSIONS.TENANT_MODELS_GRO_READ
    : clientPermission;
}

export function groWritePermission(scope: GroCrudScope, clientPermission: string) {
  return isCompanyGroScope(scope)
    ? PERMISSIONS.TENANT_MODELS_GRO_WRITE
    : clientPermission;
}
